import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import prompt from '../../assets/icons/movePrompt.svg'

const useStyles = makeStyles(() => ({
    dragImage: {
        position: 'absolute',
        bottom: '40%',
        width: '100%',
        height: 50,
        backgroundImage: `url(${prompt})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'none',
        visibility: 'visible',
        opacity: 1,
        zIndex: 1,
        transition: 'opacity 1s linear 0s',
    }
}));

export default function DragPopUp() {
    const [show, setShow] = React.useState(true)
    const classes = useStyles();

    React.useEffect(() => {
        let timer1 = setTimeout(() => setShow(false), 3000)
        // this will clear Timeout when component unmount like in willComponentUnmount
        return () => {
            clearTimeout(timer1);
        }
    }, [])

    return show && <div className={classes.dragImage}></div>
}